import React, { Component } from 'react';
import Swal from "sweetalert2/dist/sweetalert2.js";
import { Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, UncontrolledTooltip } from 'reactstrap';
import FormCreate from './FormCreate';
import IndexFormatQrQuestion from './FormatQrQuestion/Index';

class Index extends Component {
    constructor(props) {
        super(props)
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            data: [],
            modal: false,
            modeEdit: false,
            showTable: false,
            format_qr_id: "",
            format_qr: {},

            form: {
                format_id: this.props.format.id,
                name: "", 
                format_target_id: "", 
                type_to_answer: "",
                message: "",
            },
        }
    }

    handleChangeAutocomplete = selectedOption => {
        this.setState({
            selectedOption,
            form: {
                ...this.state.form,
                format_target_id: selectedOption.value
            }
        });
    };

    HandleChange = (e) => {
        this.setState({
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value,
            }
        });
    }

    toogle = (from) => {
        if (from == "new") {
            this.setState({ modal: true })
            this.clearValues();
        } else {
            this.setState({ modal: false })
        }
    }

    //add items
    updateData = (data) => {
        this.setState({
            data: [...this.state.data, data],
        })
    }

    //add update
    updateItem = format => {
        this.setState({
            data: this.state.data.map(item => {
                if (format.id === item.id) {
                    return {
                        ...item,
                        name: format.name, 
                        type_to_answer: format.type_to_answer, 
                        message: format.message, 
                        format_target: format.format_target, 
                    }
                }
                return item;
            })
        });
    }

    clearValues = () => {
        this.setState({
            modeEdit: false,

            form: {
                ...this.state.form,
                name: "", 
                format_target_id: "", 
                type_to_answer: "",
                message: "",
            },

            selectedOption: {
                label: "Seleccione el formulario",
                format_target_id: "", 
            },
        })
    }

    delete = id => {
        Swal.fire({
            title: "¿Estás seguro?",
            text: "¡El registro será eliminado para siempre!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#009688",
            cancelButtonColor: "#d33",
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar"
        }).then(result => {
            if (result.value) {
                fetch(`/formatos/format_qrs/${id}`, {
                    method: "delete",
                    headers: {
                        "X-CSRF-Token": this.token,
                        "Content-Type": "application/json"
                    }
                })
                    .then(response => response.json())
                    .then(response => {
                        this.loadData()
                        this.messageSuccess(response)
                    });
            }
        });
    };

    componentDidMount = () => {
        this.loadData();
    }

    loadData = () => {
        fetch(`/formatos/format_qrs/${this.props.format.id}`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
            this.setState({
                data: data.data,
                isLoaded: false
            });
        });
    }

    HandleClick = () => {
        if (this.state.modeEdit) {
            fetch(`/formatos/format_qrs/${this.state.format_qr_id}`, {
                method: 'PATCH', // or 'PUT'
                body: JSON.stringify(this.state.form), // data can be `string` or {object}!
                headers: {
                    "X-CSRF-Token": this.token,
                    "Content-Type": "application/json"
                }
            })

                .then(res => res.json())
                .catch(error => console.error("Error:", error))
                .then(data => {
                    this.updateItem(data.register)
                    this.clearValues();
                    this.setState({ modal: false })
                });
        } else {
            fetch(`/formatos/format_qrs`, {
                method: 'POST', // or 'PUT'
                body: JSON.stringify(this.state.form), // data can be `string` or {object}!
                headers: {
                    "X-CSRF-Token": this.token,
                    "Content-Type": "application/json"
                }
            })
                .then(res => res.json())
                .catch(error => console.error("Error:", error))
                .then(data => {
                    this.updateData(data.register)
                    this.clearValues();
                    this.setState({ modal: false, showTable: true })
                });
        }
    }


    edit = (format_qr) => {
        this.setState({
            modal: true,
            modeEdit: true,
            format_qr_id: format_qr.id,
            form: {
                ...this.state.form,
                name: format_qr.name, 
                format_target_id: format_qr.format_target.id, 
                type_to_answer: format_qr.type_to_answer,
                message: format_qr.message,
            },

            selectedOption: {
                label: format_qr.format_target.name,
                format_target_id: format_qr.format_target.id, 
            },
        })
    }

    setFormatQrQuestion = (format_qr) => {
        this.setState({
            format_qr: format_qr,
        })
    }

    clearValuesFormatQrQuestion = () => {
        this.setState({
            format_qr: {}
        })
    }

    render() {
        return (
            <React.Fragment>
                <Modal isOpen={this.props.modal} toggle={this.props.toggle} className="modal-dialog-centered modal-lg" backdrop={this.props.backdrop}>
                    <ModalHeader toggle={this.props.toggle}>{this.props.title}</ModalHeader>

                    <ModalBody>

                        {this.state.modal && (
                            <FormCreate
                                toggle={this.toogle}
                                nameBnt={this.state.modeEdit ? "Actualizar" : "Crear"}

                                //form props
                                formValues={this.state.form}
                                onChangeForm={this.HandleChange}
                                submitForm={this.HandleClick}
                                formatos={this.props.formatos}

                                handleChangeAutocomplete={this.handleChangeAutocomplete}
                                selectedOption={this.state.selectedOption}
                                errorValues={true}
                            />
                        )}

                        <div className="col-md-12 mb-3 text-right pr-0">
                            {!this.state.modal && (
                                <button
                                    className="btn-shadow btn btn-info"
                                    onClick={() => this.toogle("new")}
                                >
                                    Abrir formulario
                                </button>
                            )}
                        </div>

                        <div className="card">
                            <div className="background-gray">
                                <table className="table " id="sampleTable">
                                    <thead style={{ borderTop: "hidden", borderBottom: "hidden", color: "gray" }}>
                                        <tr>
                                            <th>Nombre</th>
                                            <th>Formato</th>
                                            <th>Tipo de respuesta</th>
                                            <th>Mensaje</th>
                                            <th style={{ width: "14%" }}>Registros</th>
                                            <th className="text-right">Acciones</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {this.state.data.length >= 1 ? (
                                            this.state.data.map((format_qr, index) => (
                                                <React.Fragment>
                                                    {index >= 1 ? <div className="mb-2"></div> : null}
                                                    <tr key={format_qr.id} className="tr-table-task" style={{ borderLeft: `4px solid green` }}>
                                                        <td>{format_qr.name}</td>
                                                        <td>{format_qr.format_target.name}</td>
                                                        <td>{format_qr.type_to_answer}</td>
                                                        <td className="text-center">
                                                            {format_qr.message && (
                                                                <React.Fragment>
                                                                    <UncontrolledTooltip target={`ui-headerTitle-tootltip${format_qr.id}`}>{format_qr.message}</UncontrolledTooltip>
                                                                    <i className="fas fa-info-circle pr-1" id={`ui-headerTitle-tootltip${format_qr.id}`}></i>
                                                                </React.Fragment>
                                                            )}
                                                        </td>
                                                        <td>
                                                            <a 
                                                                data-toggle="collapse" 
                                                                href={`#collapseExample${format_qr.id}`}
                                                                style={{ color: this.state.format_qr.id == format_qr.id ? "red" : "#16aaff"  }}
                                                                onClick={() => this.state.format_qr.id == format_qr.id ? this.clearValuesFormatQrQuestion() : this.setFormatQrQuestion(format_qr)}
                                                            >
                                                                {this.state.format_qr.id == format_qr.id ? "Cerrar" : "Ver registos" }
                                                            </a>
                                                        </td>

                                                        <td className="text-right">
                                                            {true && (
                                                                <UncontrolledDropdown direction="left" className='btn-group'>
                                                                    <DropdownToggle className='btn-shadow btn btn-info'>
                                                                        <i className="fas fa-bars"></i>
                                                                    </DropdownToggle>
                                                                    <DropdownMenu className="dropdown-menu dropdown-menu-right">
                                                                        {true && (
                                                                            <DropdownItem
                                                                                className="dropdown-item"
                                                                                onClick={() => this.setFormatQrQuestion(format_qr)}
                                                                            >
                                                                                Crear qrs
                                                                            </DropdownItem>
                                                                        )}

                                                                        {true && (
                                                                            <DropdownItem
                                                                                className="dropdown-item"
                                                                                onClick={() => this.edit(format_qr)}
                                                                            >
                                                                                Editar
                                                                            </DropdownItem>
                                                                        )}
                                                                        
                                                                        {true && (
                                                                            <DropdownItem
                                                                                onClick={() => this.delete(format_qr.id)}
                                                                                className="dropdown-item"
                                                                            >
                                                                                Eliminar
                                                                            </DropdownItem>
                                                                        )}
                                                                    </DropdownMenu>
                                                                </UncontrolledDropdown>
                                                            )}
                                                        </td>
                                                    </tr>
                                                    

                                                    {(this.state.format_qr.id == format_qr.id) && (
                                                        <tr>
                                                            <td colSpan="6">
                                                                <IndexFormatQrQuestion
                                                                    format_qr={this.state.format_qr}
                                                                    format={this.props.format}
                                                                />
                                                            </td>
                                                        </tr>
                                                    )}

                                                </React.Fragment>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="8" className="text-center">
                                                    <div className="text-center mt-4 mb-4">
                                                        <h4>No hay registros</h4>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>


                    </ModalBody>

                </Modal>
            </React.Fragment>
        );
    }
}

export default Index;
